import { RequestService } from '../../../../common/services/RequestService';
import { GET_TEMPLATE_BY_ID } from '../constants';
import { adjustTemplateById } from './adjustTemplateById';

export const getTemplateByIdRequest = async (profileId, templateId) => {
  const response = await RequestService.get(
    GET_TEMPLATE_BY_ID.replace('{profile_id}', profileId).replace(
      '{offer_template_id}',
      templateId
    )
  );
  return response.data && adjustTemplateById(response.data);
};
